/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { setSentryUser } from '@/config/sentry';

export default {
    setUser(state, data) {
        localStorage.setItem('user', JSON.stringify(data));
        state.user = data;
        setSentryUser(data, state.company);
    },
    setCompany(state, data) {
        localStorage.setItem('company', JSON.stringify(data));
        state.company = data;
        setSentryUser(state.user, data);
    },
    setToken(state, token) {
        localStorage.setItem('token', JSON.stringify(token));
        state.token = token;
    },
    setRole(state, role) {
        localStorage.setItem('role', JSON.stringify(role));
        state.role = role;
    },
    setPermissions(state, permissions) {
        localStorage.setItem('permissions', JSON.stringify(permissions));
        state.permissions = permissions;
    },
};
